$(document).ready(function () {

    fade_duration = 500;
    fade_easing = 'easeOutCirc';

    $('.sub-nav').hide();

    $('.full nav > ul > li > a').on('click', function (e) {

        e.preventDefault();

        //If no children take directly to category page
        if ($(this).closest('li').find('.sub-nav > ul > li').length < 1) {
            location.href = $(this).attr('href');
        }

        //
        oldnav = $('.sub-nav:visible');

        if (oldnav.length > 0) {
            oldnav.fadeOut(fade_duration, fade_easing);
        }

        li = $(this).closest('li');

        subnav = li.find('.sub-nav');

        if (subnav.length > 0) {
            subnav.fadeIn(fade_duration, fade_easing);
            $('body').addClass('subnav-open');

            $('.full nav > ul > li').removeClass('active');
            li.addClass('active');
        }
        else {
            $('body').removeClass('subnav-open');
        }

    });

    $('.full nav .close').on('click', function (e) {

        e.preventDefault();

        subnav = $(this).closest('.sub-nav');

        subnav.fadeOut(fade_duration, fade_easing);
        $('body').removeClass('subnav-open');

        $('.full nav > ul > li').removeClass('active');
    });

    //
    $('.small .hamburger').on('click', function (e) {

        e.preventDefault();

        $('body').addClass('small-nav-open');

    });

    $('.small .close').on('click', function (e) {

        e.preventDefault();

        $('body').removeClass('small-nav-open');

    });

    $('.small nav > ul > li').on('click', function (e) {

        e.preventDefault();

        var link = $(this).find('a');

        if (link.hasClass('sale')) {
            location.href = 'sale';
        }
        
        $('.small nav li .sub-nav').slideUp();

        $(this).find('.sub-nav').slideDown();

    });

    $('.small .sub-nav li').on('click', function (e) {

        e.preventDefault();

        href = $(this).find('a').attr('href');

        location.href = href;

        return false;

    });

});
